import React from 'react';

const UnselectedCheckbox = ({ color = 'currentColor' }: { color: string }) => {
  return (
    <svg
      width="22"
      height="23"
      viewBox="0 0 22 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15.125 4.625H6.875C5.35622 4.625 4.125 5.85622 4.125 7.375V15.625C4.125 17.1438 5.35622 18.375 6.875 18.375H15.125C16.6438 18.375 17.875 17.1438 17.875 15.625V7.375C17.875 5.85622 16.6438 4.625 15.125 4.625ZM6.875 3.25C4.59683 3.25 2.75 5.09683 2.75 7.375V15.625C2.75 17.9032 4.59683 19.75 6.875 19.75H15.125C17.4032 19.75 19.25 17.9032 19.25 15.625V7.375C19.25 5.09683 17.4032 3.25 15.125 3.25H6.875Z"
        fill={color}
      />
    </svg>
  );
};

export default UnselectedCheckbox;
